import { registerPlugin } from "@capacitor/core";
export const GigSyncSpeech = registerPlugin("GigSyncSpeech", {
    web: () => import("./web.js").then((m) => new m.GigSyncSpeechWeb()),
});
export * from "./definitions.js";
//# sourceMappingURL=index.js.map